import { CommunityExternalApi } from '../interfaces/api/external-api';
import { OutlawCommunityConfig } from '../outlaw-community.config';

export function getCommunityExternalApi(config: Partial<OutlawCommunityConfig>): CommunityExternalApi {
  return {
    ...config.externalApi,
    argo: config.externalApi?.argo || 'https://web.watchargo.com/api/',
    brandon: config.externalApi?.brandon || 'https://itsbrandontv.live/api/',
  };
}
